module.exports = __webpack_public_path__ + "media/images/emblems/Villarsel-sur-Marly-coat_of_arms-f1c72126c4de6fa11632b4467e180cb8.svg";